const questions = [
  "How worried are you about giving websites your personal information?",
  "What TV channel do you watch the most?",
  "If you could have dinner or a drink with any living person, who would you choose?",
  "Who is your hero?",
  "If you could live anywhere, where would it be?",
  "What is your biggest fear?",
  "What is your favorite family vacation?",
  "What would you change about yourself if you could?",
  "What really makes you angry?",
  "What motivates you to work hard?",
  "What is your favorite thing about your career?",
  "What is your biggest complaint about your job?",
  "What is your proudest accomplishment?",
  "What is your child's proudest accomplishment?",
  "What is your favorite book to read?",
  "What makes you laugh the most?",
  "What was the last movie you went to? What did you think?",
  "What did you want to be when you were small?",
  "What does your child want to be when he/she grows up?",
  "If you could choose to do anything for a day, what would it be?",
  "What is your favorite game or sport to watch and play?",
  "Would you rather ride a bike, ride a horse, or drive a car?",
  "What would you sing at Karaoke night?",
  "What two radio stations do you listen to in the car the most?",
  "Which would you rather do: wash dishes, mow the lawn, clean the bathroom, or vacuum the house?",
  "If you could hire someone to help you, would it be with cleaning, cooking, or yard work?",
  "If you could only eat one meal for the rest of your life, what would it be?",
  "Who is your favorite author?",
  "Have you done anything exciting lately?",
  "What made you smile today?",
  "How did you meet the host?",
  "What's your favorite form of social media?",
  "What was the last good book you read?",
  "Do you listen to any podcasts? Which is your favorite?",
  "What do you think is the best show on Netflix right now?",
  "Have you been on any interesting trips lately?",
  "What do you think has been the best movie of the year so far?",
  "What song do you wish you could put on right now?",
  "Are you a cat person or a dog person?",
  "Do you think you're an introvert or an extrovert?",
  "If you didn't have the job you have now, what would you be?",
  "What's your strangest hidden talent?",
  "What is something people are always surprised to learn about you?",
  "What is the most rewarding part of your career?",
  "Where do you want to be in five years?",
  "What superpower do you wish you could have?",
  "Where would you go on vacation if you had no budget?",
  "If you could travel back in time, what decade would you choose to live in?",
  "What's the best thing you've ever bought off Amazon?",
  "What's the last concert you went to?",
  "What is one thing you can't live without?",
  "What's the strangest dream you've had recently?",
  "What is your favorite book of all time?",
  "How many countries have you been to?",
  "What's your favorite city you've visited?",
  "Would you rather travel via plane or boat?",
  "Would you rather be really hot or really cold?",
  "What are your thoughts on the British royal family?",
  "Do you like documentaries? Have you watched any good ones recently?",
  "Who is your favorite celebrity couple ever?",
  "Which celebrity couple do you wish would get back together?",
  "If you could host a talk show, who would you have on first?",
  "What's your favorite sport?",
  "What sport do you wish you were really good at?",
  "What's the best holiday?",
  "How did you spend your last birthday?",
  "Do you believe men and women can ever just be friends?",
  "Are you having a good time?",
  "Why did you come tonight?",
  "Was it a pain for you to get here tonight?",
  "I love that shirt/jacket/dress/shoes. Where did you get it?",
  "Wow, it's so hot/cold in here.",
  "Do you know a lot of people here?",
  "What are you reading right now?",
  "What's your favorite restaurant around here?",
  "What's the next exciting event you have coming up?",
  "Doing anything fun this weekend?",
  "Do you have any pets?",
  "What's one interesting thing about yourself no one really knows?",
  "What do you do for a living?",
  "If you could move anywhere, where would you go?",
  "What was the last movie you saw?",
  "What do you normally do for fun?",
  "What hobby do you wish you had more time for?",
  "If you weren't here, what would you be doing?",
  "What is your favorite holiday?",
  "Do you have any nicknames?",
  "What's your biggest pet peeve?",
  "What is your favorite guilty pleasure TV show?",
  "Tell me three fun facts about yourself.",
  "The food looks great. What's the best thing you've had so far?",
  "Have you ever been here before?",
  "What's the best thing about your job?",
  "Where did you grow up?",
  "Do you like to cook?",
  "What hobby do you wish you were good at?",
  "What song have you had stuck in your head this week?",
  "What are your long-term goals?",
  "Who is your role model?",
  "What did you want to be when you were a kid?",
  "What is your biggest regret in life?",
  "What are the top three things on your bucket list?",
  "What has been your biggest accomplishment so far?",
  "What is one thing you wish you could do that you know you probably never will?",
  "What are you most afraid of?",
  "What's the biggest risk you've ever taken?",
  "Tell me about the most life-changing piece of advice you've ever heard.",
  "When are you the most happy?",
  "What always calms you down when you're really stressed out and upset?",
  "Who in your life has had the most influence on you?",
  "What's the hardest thing you've ever done?",
  "What scares you the most about the future?",
  "How have your priorities changed in the last 10 years?",
  "What's the nicest thing anyone has ever done for you?",
  "Describe your perfect weekend.",
  "What's the most controversial opinion you have?",
  "If you could change one thing about your personality, what would it be?",
  "What's the first thing you would do if you won the lottery?",
  "If you could invite one famous person to dinner, who would it be?",
  "Who do you miss the most from your past?",
  "If you could go back in time, what is one situation you would do differently?",
  "Who is the most important person in your life right now?",
  "What did you think you would be doing at this age when you were a kid?",
  "Do you think social media is destroying our communication?",
  "What piece of technology could you live without?",
  "What do you think the world will be like 20 years in the future?",
  "What is something you've failed at recently?",
  "What made you choose this as your career?",
  "What's the most interesting thing you've worked on lately?",
  "What do you love most about your job?",
  "What was your first job?",
  "How long have you been at your current job?",
  "Why do you think you were hired?",
  "What is the most frustrating thing about your job?",
  "What are your goals when it comes to work?",
  "What inspires you at work each day?",
  "If you could change one thing about this industry, what would it be?",
  "Who has been your career role model?",
  "Man, I really hate networking.",
  "What's the most interesting thing you've learned at work?",
  "Do you ever travel for your job? Where have you gone?",
  "How do you keep yourself organized every day?",
  "How many emails have you been avoiding answering this week?",
  "What do you think makes someone a great manager?",
  "What's the biggest challenge you've taken on this year?",
  "What's your favorite project you've worked on so far?",
  "What do you find most beneficial about networking events?",
  "Do you ever sing in the shower?",
  "What is the worst piece of advice you've ever gotten?",
  "What's the most embarrassing thing that's happened to you recently?",
  "Tell me about the worst pickup line you've ever gotten.",
  "What is your favorite celebrity scandal right now?",
  "What's the worst thing you've ever worn?",
  "If you could do anything illegal without getting in trouble, what would it be?",
  "What is the stupidest joke you've ever heard?",
  "When was the last time you laughed so hard you cried?",
  "What's the best prank you've ever played on someone?",
  "What do you think is the funniest movie ever?",
  "What always makes you laugh, even when you're upset?",
  "Who is your favorite comedian?",
  "What weird conspiracy theory do you believe?",
  "Is a hot dog a sandwich?",
  "Which celebrity would play you in a movie about your life?",
  "What's the weirdest thing you loved as a child?",
  "What is something that's really popular right now that will be ridiculous in five years?",
  "What's the worst trend you've ever taken part in?",
  "What's your go-to joke?",
  "Where do you go to school?",
  "What's your favorite subject/class?",
  "Who is your favorite teacher?",
  "Why is that person your favorite teacher?",
  "What subject do you wish you never had to take?",
  "What was the last assignment you did really well on?",
  "Who is your best friend in your grade?",
  "What's your favorite outfit to wear to school?",
  "Do you believe in aliens?",
  "If you could be any animal, which would it be?",
  "What do you want to be when you grow up?",
  "Do you have any brothers or sisters?",
  "What do you love the most about your mom and dad?",
  "Where do you wish you were right now?",
  "What's your favorite song?",
  "Who's your favorite cartoon character?",
  "Do you have a favorite Disney character?",
  "If you could change one thing about school, what would it be?",
  "Do you like to swim?",
  "What's your favorite game to play?",
  "What's your favorite color?",
  "What food do you hate?",
  "What is your favorite toy to play with?",
  "What are you doing tomorrow?",
  "What are you afraid of?",
  "Have you ever been here before?",
  "What is one thing that always makes you laugh?",
  "What's the most important thing I should know about you?",
  "What's the worst date you've ever been on?",
  "How did you become close with your best friend?",
  "What's your favorite movie that you could watch over and over again?",
  "What has always been your dream job?",
  "If you could date one celebrity, who would it be?",
  "Are you a spender or a saver?",
  "What do you like most about your job?",
  "What do you think is your most annoying quirk?",
  "What's the weirdest text message you've ever gotten?",
  "What do you hate the most about dating?",
  "Where's your favorite place in the world?",
  "What's the best vacation you've ever been on?",
  "How close are you with your family?",
  "Do you prefer to stay in or go out?",
  "Where did you go to school?",
  "Have you ever lived anywhere else?",
  "What are you good at that you're really proud of?",
  "What's your secret talent?",
  "What do you think is the most annoying habit?",
  "Tell me about one thing on your bucket list.",
  "What do you dislike most about your job?",
  "What are you the most passionate about?",
  "Do you like calling or texting better?",
  "What are your honest thoughts about social media?",
  "What do you look for in a relationship?",
  "Did you hear about (a big news story)?",
  "What is one thing that made you laugh this week?",
  "What's your favorite food?",
  "What's the worst thing you've ever eaten?",
  "What movie are you really excited to see?",
  "How do you spend your free time?",
  "Are you a morning person or a night owl?",
  "What are you drinking?",
  "What drink should I order next?",
  "Have you ever been here before?",
  "What's your favorite bar?",
  "What's your favorite thing to eat here?",
  "Do you like this song?",
  "If you could have them play any song right now, what would it be?",
  "What were you doing before you came here?",
  "What's your favorite place to hang out around here?",
  "Are you having fun?",
  "Who are you here with?",
  "Where would you rather be right now?",
  "Which song would you make you dance at this very moment?",
  "How do you always get a bartender's attention?",
  "Would you ever dance on top of this bar?",
  "Have you ever done karaoke?",
  "I like your shirt, where did you get that?",
  "How do you know the friends you're here with?",
  "Do you know so-and-so?",
  "What made you laugh today?",
  "If you could only eat one food for the rest of your life, what would it be?",
  "What's your best tip for saving money?",
  "What is your favorite quote right now?",
  "Have you talked to so-and-so lately?",
  "What have you been up to since I saw you last?",
  "Has anything big changed at work?",
  "How are your parents doing?",
  "What have you been loving on TV lately?",
  "What's your best tip for a good morning routine?",
  "What's your best cooking tip?",
  "What's the weirdest thing you've seen on Facebook recently?",
  "Where is your favorite place to shop?",
  "How was your last vacation?",
  "Where is the coolest place you've been to for dinner lately?",
  "What's your go-to dish to bring to a dinner party?",
  "What did you do last weekend?",
  "What app do you use everyday?",
  "What's the weirdest thing in your fridge right now?",
  "What are your plans for next summer?",
  "What's your favorite thing you've bought recently?",
  "How can you tell when someone is lying?",
  "What's your most irrational fear?",
  "Have you ever really kept a New Year's resolution?",
  "If you could change your name, what would you change it to?",
  "How would your life be different if social media didn't exist?",
  "What do you think my best personality trait is?",
  "What did you notice first about me?",
  "What's your favorite thing to do on your day off work?",
  "What was the first job you ever had?",
  "What's the best compliment you've ever gotten?",
];

export default questions;
